import { render } from "./MethodologyComponent.vue?vue&type=template&id=a3d6fee8&scoped=true&ts=true"
import script from "./MethodologyComponent.vue?vue&type=script&lang=ts"
export * from "./MethodologyComponent.vue?vue&type=script&lang=ts"

import "./MethodologyComponent.vue?vue&type=style&index=0&id=a3d6fee8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3d6fee8"]])

export default __exports__